import { gql } from '@apollo/client';

export const CREATE_WITHDRAW_TRANSFER = gql`
  mutation createWithdrawTransfer($input: CreateWithdrawTransferInput!) {
    createWithdrawTransfer(input: $input) {
      transfer {
        id
        state
      }
    }
  }
`;

export const CREATE_SCHEDULED_WITHDRAW_TRANSFER = gql`
  mutation createScheduledWithdrawTransfer(
    $input: CreateScheduledWithdrawTransferInput!
  ) {
    createScheduledWithdrawTransfer(input: $input) {
      scheduledTransfer {
        id
        state
      }
    }
  }
`;

export const CREATE_WITHDRAW_ALL_TRANSFER = gql`
  mutation withdrawAllFromSubAccount($input: WithdrawAllSubAccountInput!) {
    withdrawAllFromSubAccount(input: $input) {
      transfer {
        id
        state
      }
    }
  }
`;
